/**
 * メインアプリケーションコンポーネント
 * プロバイダーとルーターの設定
 */

import { SupabaseAuthProvider } from '@/shared/hooks/useSupabaseAuth'
import { ThemeProvider } from './providers/ThemeProvider'
import { AppRouter } from './router/AppRouter'

/**
 * アプリケーションコンポーネント
 */
function App() {
  return (
    <ThemeProvider defaultTheme="system" storageKey="genbaflow-ui-theme">
      <SupabaseAuthProvider>
        <AppRouter />
      </SupabaseAuthProvider>
    </ThemeProvider>
  )
}

export default App
